var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { getValueKey } from '@juvare/common-form-ui/WidgetForm/Utils';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { getDataValue, removeDataValue, setDataValue } from '@juvare/json-data-util';
import { Autocomplete, CircularProgress, ListItem, Radio, TextField } from '@mui/material';
import React from 'react';
import { useValues } from '../hooks';
import { removeValuesFromComponentDependencies } from '../utils/deleteComponentDependencies';
export const QuickFilterSelect = (_a) => {
    var _b, _c;
    var { valueProviders: valueProvidersFromProps, dataPath, label, values, valueProviderType, valueProvider, filterData, onChangeFilterData, sx, filterDependencies } = _a, props = __rest(_a, ["valueProviders", "dataPath", "label", "values", "valueProviderType", "valueProvider", "filterData", "onChangeFilterData", "sx", "filterDependencies"]);
    const [items, loading] = useValues({ values, valueProviderType, valueProvider, valueProvidersFromProps, filterData });
    const textFieldRef = React.useRef(null);
    const value = getComponentValue(filterData, dataPath);
    const valueObject = (_b = items.filter((item) => value === item.value)) !== null && _b !== void 0 ? _b : null;
    const labelWithChipCount = value != null ? label + ' (1)' : label;
    return (React.createElement(Autocomplete, { multiple: true, fullWidth: true, size: 'small', value: valueObject, options: items, getOptionKey: (option) => getValueKey(option.value), loading: loading, openOnFocus: true, renderInput: (params) => (React.createElement(TextField, Object.assign({ ref: textFieldRef }, params, { label: '', placeholder: labelWithChipCount, InputProps: Object.assign(Object.assign({}, params.InputProps), { endAdornment: loading ? (React.createElement(React.Fragment, null,
                    React.createElement(CircularProgress, { color: 'inherit', size: 20 }),
                    params.InputProps.endAdornment)) : (params.InputProps.endAdornment) }), sx: {
                flex: '1 1 0',
                minWidth: 0,
                '& input.MuiOutlinedInput-input.MuiAutocomplete-input.MuiInputBase-inputSizeSmall': {
                    // adding 2px to so that height is 42px instead of 40px
                    paddingTop: '6.5px', // magic value = 5.5px (value from JuvareTheme) + 1px
                    paddingBottom: '5.5px', // magic value = 4.5px (value from JuvareTheme) + 1px
                },
                '& legend': {
                    width: 0,
                },
                '& input::placeholder': {
                    typography: 'body2',
                    color: themeColors.text.subtle,
                    opacity: 1,
                    textOverflow: 'ellipsis',
                },
            } }))), renderOption: (renderOptionProps, option, { selected }) => (React.createElement(ListItem, Object.assign({}, renderOptionProps),
            React.createElement(Radio, { sx: { mr: 1 }, checked: selected }),
            option.label)), renderTags: () => null, onChange: (_event, newValueList) => {
            var _a, _b;
            const newValue = (_b = (_a = newValueList[newValueList.length - 1]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : undefined;
            if (value !== newValue) {
                onChangeFilterData((prevFilterData) => {
                    return setComponentValue(prevFilterData, dataPath, filterDependencies, newValue);
                });
            }
        }, sx: [
            {
                flex: '1 1 0',
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ], componentsProps: {
            popper: { placement: 'bottom-start', style: { minWidth: (_c = textFieldRef.current) === null || _c === void 0 ? void 0 : _c.clientWidth, maxWidth: '100%' } },
        }, "data-test": props['data-test'] }));
};
function getComponentValue(data, dataPath) {
    const value = data ? getDataValue(data, dataPath) : undefined;
    if (value != null) {
        return value;
    }
    else {
        return undefined;
    }
}
function setComponentValue(data, dataPath, dependencyMap, value) {
    const newData = JSON.parse(JSON.stringify(data !== null && data !== void 0 ? data : {}));
    if (value != null) {
        setDataValue(newData, dataPath, value);
    }
    else {
        removeDataValue(newData, dataPath);
    }
    removeValuesFromComponentDependencies(newData, dataPath, dependencyMap);
    return newData;
}
